module.exports = __webpack_public_path__ + "img/sv38.24707bad.svg";